import React from "react";
import { TrackOrderCards } from "presto-react-components";

export default function TrackOrderCard(props) {
  return <TrackOrderCards.TrackOrderCard1 {...props} />;
}
